/**
 * Fixed HTML wrapper that produces the full email HTML document.
 * Derived from the backend DefaultEmailTemplates.kt structure.
 * Uses table-based layout with inline styles for email client compatibility.
 * The layout is locked; only the content slots are customizable.
 */

export interface EmailSections {
  greeting: string;
  bodyContent: string;
  ctaLabel: string;
  ctaLink: string;
  closingText: string;
}

const LOGO_URL = 'https://vendor.clareefai.com/logo-clareefai-white.png';

/**
 * Wraps user-edited sections into the full HTML email template.
 * Uses table-based layout matching backend DefaultEmailTemplates.kt format.
 */
export function wrapEmailHtml(sections: EmailSections): string {
  const ctaBlock = sections.ctaLabel
    ? `
									<table cellpadding="0" cellspacing="0" border="0" style="margin-bottom: 16px;" data-cta>
										<tr>
											<td align="center" bgcolor="#4339A0" style="border-radius: 6px;">
												<a href="${sections.ctaLink}" style="display: inline-block; padding: 14px 32px; color: #ffffff; text-decoration: none; font-weight: bold; font-size: 15px; font-family: Arial, Helvetica, sans-serif; line-height: 1;">${sections.ctaLabel}</a>
											</td>
										</tr>
									</table>

									<p style="margin: 0 0 4px 0; font-size: 13px; color: #888888; font-family: Arial, Helvetica, sans-serif;">Or copy and paste this link into your browser:</p>
									<p style="margin: 0 0 28px 0; font-size: 12px; color: #4339A0; word-break: break-all; font-family: Arial, Helvetica, sans-serif;" data-link-text>${sections.ctaLink}</p>`
    : '';

  return `<!DOCTYPE html>
<html lang="en">
<head>
	<meta charset="UTF-8">
	<meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body style="margin: 0; padding: 0; background-color: #f4f4f7; font-family: Arial, Helvetica, sans-serif;">
<table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#f4f4f7">
	<tr>
		<td align="center" style="padding: 40px 16px;">
			<table width="560" cellpadding="0" cellspacing="0" border="0" bgcolor="#ffffff" style="border: 1px solid #e2e2e8; border-radius: 10px;" data-container>

				<!-- Header -->
				<tr>
					<td style="padding: 24px 40px; border-radius: 10px 10px 0 0;" bgcolor="#4339A0">
						<table width="100%" cellpadding="0" cellspacing="0" border="0">
							<tr>
								<td align="left" valign="middle">
									<img src="${LOGO_URL}" alt="Clareefai" height="32" style="display: block;" />
								</td>
								<td align="right" valign="middle">
									{{vendorLogoHtml}}
								</td>
							</tr>
						</table>
					</td>
				</tr>

				<!-- Body -->
				<tr>
					<td bgcolor="#ffffff" style="padding: 36px 40px; border-radius: 0 0 10px 10px;" data-body>

						<p style="margin: 0 0 16px 0; font-size: 16px; line-height: 1.6; color: #333333; font-family: Arial, Helvetica, sans-serif;" data-greeting>
							${sections.greeting}
						</p>

						${sections.bodyContent}

						${ctaBlock}

						<p style="margin: 0 0 28px 0; font-size: 14px; color: #666666; line-height: 1.6; font-family: Arial, Helvetica, sans-serif;" data-closing>
							${sections.closingText}
						</p>

					</td>
				</tr>


			</table>
		</td>
	</tr>
</table>
</body>
</html>`;
}
